__turbopack_context__.v({
  "location": "StickyInfo-module__zdOPoW__location",
  "modalBody": "StickyInfo-module__zdOPoW__modalBody",
  "modalContainer": "StickyInfo-module__zdOPoW__modalContainer",
  "sticky": "StickyInfo-module__zdOPoW__sticky",
  "stickyInfo": "StickyInfo-module__zdOPoW__stickyInfo",
  "stickyInfoCompact": "StickyInfo-module__zdOPoW__stickyInfoCompact",
  "stockUnavailable": "StickyInfo-module__zdOPoW__stockUnavailable",
});
